import { paymentTermsStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsPaymentTerms";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

paymentTermsStyles.titleText = mergeToNew(paymentTermsStyles.titleText, {
    variant: "h3",
    css: css`
        margin-bottom: 0px;
    `,
});
